import { useMemo } from "react";
import { useSelector } from "react-redux";

const useHasEditAccess = () => {
  const showAllLocations = useSelector((state) => state.schedule.showAllLocations);

  const userPermissions = useSelector((state) => state.personalProfile.fullUserPermissions);
  const hasEditAccess = useMemo(
    () => (
      !showAllLocations &&
      (
        userPermissions['scheduleEdit'] ||
        userPermissions['scheduleFullAccess'] ||
        userPermissions['worklogsEdit'] ||
        userPermissions['worklogsFullAccess']
      )
  ), [userPermissions, showAllLocations]);
  return { hasEditAccess }
}

export default useHasEditAccess;